<template>
  <QuesCard
    :maxwidth="maxwidth"
    :isEdit="isEdit"
    :ques="ques"
    @quesDel="$emit('quesDel')"
  >
    <template slot="title">
      {{ ques.serial == null ? '' : ques.serial + '. ' }}星級評分題
    </template>
    <v-card-text slot="content" class="text-start">
      <template v-if="!isEdit">
        <div v-for="(name, idx) in ques.cnName.split(/\r?\n/)" :key="idx">{{ ques.serial == null ? '' : ques.serial + '. ' }}{{ name }}</div>
        <!-- 加上題號在非編輯狀態 -->
      </template>      
      <!-- *******[Start] 編輯模式 isEdit=true 時才會出現的區域******** -->
      <template v-if="isEdit">
        <v-textarea
          outlined
          rows="1"
          label="題目內容"
          auto-grow
          v-model="ques.cnName"
          class="peter-text"
          v-on:click="checkDef()"
        ></v-textarea>        
        </template>
        <v-row class="mt-2 ml-0 pr-3">
        <v-file-input
          v-if="isEdit"
          chips
          filled
          class="pt-0"
          v-model="ques.headingFile"
          accept="image/*"
          @change="onImgChangeHeading($event)"
          label="File input"
        >
        </v-file-input>
      </v-row>
      <v-row>
        <v-col class="pa-0 text-center" >
          <!-- <v-img></v-img> 改成 <img> 來顯示圖片原始的最大尺寸 max-width控制不破圖 -->
          <img
            v-if="ques.questHeadingPic"
            :src="
              ques.questHeadingPic.startsWith('data')
                ? ques.questHeadingPic
                : $store.state.server + ques.questHeadingPic
            "
            style="max-width: 100%"
          />
        </v-col>
      </v-row>
        <template v-if="isEdit">
        <v-row>
          <v-col cols="12" sm="3" md="2">
            <v-text-field
              dense
              label="最大值"
              v-model="ques.length"
              :min="2"
              :max="7"
              outlined
              onInput="if (Number(this.value) > Number(this.max)) this.value = this.max"
              class="centered-input peter-text"
              type="number"
            ></v-text-field>
          </v-col>
        </v-row>
      </template>      
      <!-- *******[End] 編輯模式 isEdit=true 時才會出現的區域******** -->
      <v-rating
        v-model="ques.value"
        :length="ques.length"
        :align="'center'"
        :justify="'center'"
        class="mb-3"
        x-large
      ></v-rating>
    </v-card-text>
  </QuesCard>
</template>

<script>
import QuesCard from './QuesCard'
export default {
  components: {
    QuesCard
  },
  props: {
    isEdit: {
      type: Boolean,
      default: false
    },
    maxwidth: {
      type: Number,
      default: null
    },
    ques: {
      type: Object,
      default: () => {
        return {
          title: '星級評分題',
          cnName: '星級評分題題目內容',
          length: 5,
          value: 3
        }
      }
    }
  },
  computed:{
     QType() {
      return this.$store.state.QType
    },
  },
   methods: {
     onImgChangeHeading(file) {
      if (!file) {
        this.ques.questHeadingPic = null
      } else {
        var fileReader = new FileReader()
        fileReader.addEventListener('load', (e) => {
          this.ques.questHeadingPic = e.target.result
        })
        fileReader.readAsDataURL(file)
      }
    },
    checkDef() {
      if (this.QType.RATING.template.cnName === this.ques.cnName) {
        this.ques.cnName = ''
      }      
    },
  },
}
</script>

<style lang="scss" scoped>
.thiscard {
  border-radius: 10px;
  cursor: grab;
}
</style>
